function setCookie(name, value, days = 30) {
  const d = new Date();
  d.setTime(d.getTime() + days*24*60*60*1000);
  document.cookie = `${name}=${value}; path=/; expires=${d.toUTCString()}`;
}

function getCookie(name) {
  const match = document.cookie.split('; ').find(row => row.startsWith(name + '='));
  return match ? match.split('=')[1] : null;
}

function showPopup() {
  const popup = document.getElementById('region-popup');
  popup.style.display = 'block';

  document.getElementById('go-us').addEventListener('click', () => {
    setCookie('regionChoice', 'us', 30);
    window.location.href = 'https://airsonett.com'; 
  });

  document.getElementById('stay-here').addEventListener('click', () => {
    setCookie('regionChoice', 'eu', 30);
    popup.style.display = 'none';
  });

  document.getElementById('popup-close').addEventListener('click', () => {
    setCookie('regionChoice', 'closed', 1);
    popup.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (getCookie('regionChoice')) return;

  fetch('https://ipapi.co/json/')
    .then(res => res.json())
    .then(data => {
      if (data.country === 'US') {
        showPopup();
      }
    })
    .catch(err => console.error('Geo-IP lookup failed:', err));
});
